module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/checkout-thankyou/checkout-thankyou.component.css
// module id = ./src/app/admin/checkout-thankyou/checkout-thankyou.component.css
// module chunks = main